/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const scheduleRenameBodyExpectedVersionExclusiveMin = 0;
export const scheduleRenameBodyExpectedVersionMax = 9007199254740991;

export const ScheduleRenameBody = zod.object({
  teamId: zod.unknown().optional(),
  scheduleId: zod.unknown().optional(),
  timeZone: zod.unknown().optional(),
  name: zod.string(),
  expectedVersion: zod
    .int()
    .gt(scheduleRenameBodyExpectedVersionExclusiveMin)
    .max(scheduleRenameBodyExpectedVersionMax),
});

export type ScheduleRenameBody = zod.input<typeof ScheduleRenameBody>;
export type ScheduleRenameBodyOutput = zod.output<typeof ScheduleRenameBody>;
